import React from 'react';

const DistributionScreen = () => {
  return <>직원별 분출 통계</>;
};

export default DistributionScreen;
